module.exports = __webpack_public_path__ + "img/logo-red-branco-3x.a6bb9f31.png";